import React from "react";

const NotFound = React.lazy(() => import("./NotFound"));

export const NotFoundAsync = (props) => (
  <React.Suspense fallback={false}>
    <NotFound {...props} />
  </React.Suspense>
);

export default NotFoundAsync;
